import { Schema as S } from "effect";
export const Schema = S.String.pipe(S.brand("@open-revenue/schema/StoreProductGroupId"), S.annotations({
    description: "A unique identifier for a product group in the store, this could be a paddle product group id, a stripe product id, or a google play product id"
}));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
